var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab-area"},_vm._l((_vm.tabs),function(item,key){return _c('li',{key:key,class:{'current': item.mode === _vm.mode},on:{"click":function($event){return _vm.changeMode(item.mode)}}},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }